import React, { useState } from "react";
import camera from "../../images/Svg/desoSignup/camera.svg";
import placeHolderInput from "../../images/Svg/desoSignup/placeHolderInput.svg";
import cameraHover from "../../images/Svg/desoSignup/camera_hover.svg";
import userIcon from "../../images/Svg/desoSignup/userIcon.svg";
import { useContext } from "react";
import { ConfigContext } from "../../context/config";
import {
  checkDesoUserNameApi,
  getDataforProfilePageApi,
} from "../../Network/network";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../spinner/Spinner.component";
import {
  setUpdateProfileData,
  setUpdateProfileStateRedux,
} from "../../reducers/auth/action";
import { useEffect } from "react";
import Swal from "sweetalert2";
import useIdentity from "../../utils/identity";
import Iframe from "../iframe/Iframe.component";
import { gaEvents, pushGaEvent } from "../../utils/ga_events";

export default function StepTwo() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const { setStep } = useContext(ConfigContext);

  const { deso, updateProfileState, desoUserProfileData } = useSelector(
    (state) => state.auth
  );
  const { handleMessage } = useIdentity();

  const { setRemaining, setUpdateProfileState } = useContext(ConfigContext);
  const [required, setRequired] = useState(false);
  const [banner, setBanner] = useState();
  const [photo, setPhoto] = useState();
  const [username, setUsername] = useState();
  const [usernameExists, setUsernameExists] = useState(false);
  const [data, setData] = useState();
  const [bio, setBio] = useState();
  const [email, setEmail] = useState();
  const [buttonText, setButtonText] = useState("Save");
  const handlePickFile = (id) => {
    const bannerInput = document.getElementById(id);
    bannerInput.click();
  };

  useEffect(() => {
    if (deso?.user) {
      fetchProfileData();
    }
  }, [deso?.user]);

  let bodyData = {
    public_key: deso?.user?.publicKeyAdded,
    jwt: "eyJhbGciOiJFUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE2MTk2NDk4MDcsImV4cCI6MTYxOTY0OTg2N30.FKZF8DSwwlnUaW_eRa7Wr1v2QcG7_iDN-NjdqXUcgrSAPg1EdSfpWsLL4GeUiD9zdLUgrNoKU7EsKkE-ZKMaVQ",
  };

  const fetchProfileData = async () => {
    const res = await getDataforProfilePageApi(bodyData);
    if (res?.username !== "" && res?.username) {
      setUsername(res.username);
      setData(res);
      setEmail(res?.email);
      setBio(res?.description);
      setPhoto(res?.profile_pic);
      setBanner(res?.cover_pic);
    } else {
      setButtonText("Save");
    }
    setLoading(false);
  };

  useEffect(() => {
    if (
      data?.username == username &&
      email == data?.email &&
      bio == data?.description &&
      photo == data?.profile_pic &&
      banner == data?.cover_pic
    ) {
      setButtonText("Next");
    } else {
      setButtonText("Save");
    }
  }, [username, data, bio, email, photo, banner]);

  const handleBannerChange = (event) => {
    const filesize = (event.target.files[0].size / 1024 / 1024).toFixed(4);
    if (filesize <= 5) {
      getBase64(event.target.files[0]).then((result) => {
        setBanner(result);
      });
    }
  };

  // convert image to base64
  const getBase64 = (file) => {
    return new Promise((resolve) => {
      let fileInfo;
      let baseURL = "";
      // Make new FileReader
      let reader = new FileReader();
      reader.readAsDataURL(file);
      // Convert the file to base64 text
      reader.onload = () => {
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };
  const handlePhotoChange = (event) => {
    const filesize = (event.target.files[0].size / 1024 / 1024).toFixed(4);
    if (filesize <= 5) {
      getBase64(event.target.files[0]).then((result) => {
        setPhoto(result);
      });
    }
  };

  const handleSubmit = async (e) => {
    setUpdateProfileState(false);
    let count = 4;
    e.preventDefault();
    if (!username) {
      setRequired(true);
      return;
    } else setRequired(false);
    if (usernameExists) {
      return;
    }

    if (!photo) count = count - 1;
    if (!username) count = count - 1;
    if (!email) count = count - 1;
    if (!bio) count = count - 1;

    const bodyData = {
      public_key: deso?.user?.publicKeyAdded,
      email: email,
      username: username,
      profile_pic_base64: photo,
      description: bio,
      cover_pic: banner,
    };

    if (buttonText == "Save") {
      dispatch(setUpdateProfileData(bodyData));
      dispatch(
        setUpdateProfileStateRedux({
          loading: true,
          step: null,
        })
      );
      pushGaEvent(gaEvents.PROFILE_SAVE_BUTTON_CLICKED);
      setUpdateProfileState(true);
    } else {
      dispatch(
        setUpdateProfileStateRedux({
          loading: true,
          step: 3,
        })
      );
      pushGaEvent(gaEvents.PROFILE_NEXT_BUTTON_CLICKED);
      setStep(3);
    }
    setRemaining(count);

    setTimeout(() => {
      setUpdateProfileState(false);
    }, 2000);
  };

  useEffect(() => {
    if (updateProfileState?.modal) {
      Swal.fire({
        icon: "",
        html: "Something went wrong. Please try again later",
        focusConfirm: false,
        confirmButtonText: "Try Again",
      }).then(() => {
        window.location.reload();
      });
    }
  }, [updateProfileState]);

  const handleUserName = async (e) => {
    setUsername(e.target.value);
    if (e.target.value.length !== 0) {
      const res = await checkDesoUserNameApi({ username: e.target.value });
      if (res.status == true) {
        if (data?.username == e.target.value) {
          setUsernameExists(false);
        } else {
          setUsernameExists(true);
        }
      } else {
        setUsernameExists(false);
        setRequired(false);
      }
    }
  };

  useEffect(() => {
    if (updateProfileState.loading == false && updateProfileState.step == 3) {
      setStep(3);
    }
  }, [updateProfileState]);

  return loading ? (
    <Spinner />
  ) : (
    <>
      {" "}
      <div className="mt-[24px]">
        <Iframe />
        <form onSubmit={handleSubmit}>
          <div className="grid sm:grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="mb-[50px]">
              <h4 className="text-[18px]">
                Add a profile picture and a banner image
              </h4>
              <p className="text-[14px] pt-[8px]">
                Only JPEG, PNG, JPG files are allowed. Max. size limit is{" "}
                <span className="text-[#DC6B03]">5MB</span>.
              </p>

              <div className="mx-auto lg:mx-0 bg-[#FFFFFF] border border-[#E1E1E1] h-[165px] sm:h-[273px] w-[294px] sm:w-[486px] mt-[24px] lg:max-w-[486px]  lg:w-[100%] 2xl:h-[342px] flex justify-center items-center cursor-pointer relative">
                {banner ? (
                  <>
                    <img className="w-full h-full" src={banner} alt="" />
                  </>
                ) : (
                  <div>
                    <img src={placeHolderInput} alt="" />
                  </div>
                )}
                <input
                  onChange={(e) => handleBannerChange(e)}
                  className="hidden"
                  type="file"
                  accept="image/png, image/jpeg"
                  id="image_picker"
                />
                <div
                  onClick={() => handlePickFile("image_picker")}
                  className="absolute bottom-[5px] right-[5px] z-10 select_hover"
                >
                  <div className="arrow_img">
                    <img src={camera} alt="" />
                  </div>
                  <div className="arrow_show hidden">
                    <img src={cameraHover} alt="" />
                  </div>
                </div>
                <div
                  onClick={() => handlePickFile("profile_photo_picker")}
                  className="absolute -bottom-[50px]  z-10"
                >
                  <div className="relative w-[100px] h-[100px] justify-center flex items-center bg-white border border-[#E1E1E1]  rounded-[800px]">
                    <input
                      onChange={(e) => handlePhotoChange(e)}
                      className="hidden"
                      type="file"
                      accept="image/png, image/jpeg"
                      id="profile_photo_picker"
                    />
                    <img
                      className={
                        photo ? "w-[95px] h-[95px] rounded-[50px]" : ""
                      }
                      src={photo ? photo : userIcon}
                      alt=""
                    />
                    <div className="absolute bottom-0 right-0 select_hover">
                      <div className="arrow_img">
                        <img src={camera} alt="" />
                      </div>
                      <div className="arrow_show hidden">
                        <img src={cameraHover} alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div className="mb-[24px]">
                <div>
                  <h4
                    className={`${
                      required ? "text-[#DC6B03]" : "text-[#000000]"
                    } text-[18px] pb-[8px]`}
                  >
                    Username (required)
                  </h4>
                </div>
                <div>
                  <input
                    onChange={(e) => handleUserName(e)}
                    className={` ${
                      required
                        ? "border-[#DC6B03] border-[2px]"
                        : "border-[#E1E1E1] border"
                    }  p-[10px] w-full rounded-[8px] focus:outline-none`}
                    placeholder="Type your username"
                    type="text"
                    value={username}
                  />

                  <div className=" mt-[5px] h-[20px]">
                    {usernameExists && data?.username !== username
                      ? username != "" && (
                          <p className="text-[#DC6B03] text-[14px]">
                            {username} is already taken
                          </p>
                        )
                      : username != "" &&
                        username && (
                          <p className="text-[#19A702] text-[14px]">
                            {username} is available
                          </p>
                        )}
                  </div>
                </div>
              </div>
              <div className="my-[24px]">
                <div>
                  <h4 className="text-[18px] pb-[8px]">Enter your email</h4>
                </div>
                <div>
                  <input
                    onChange={(e) => setEmail(e.target.value)}
                    className="border border-[#E1E1E1] p-[10px] w-full rounded-[8px] focus:outline-none"
                    placeholder="Email ID"
                    type="text"
                    value={email}
                  />
                  <p className="pt-[8px] text-[14px]">
                    Your email address will not be shared with anyone.
                  </p>
                </div>
              </div>
              <div>
                <div>
                  <p className="pt-[8px] pb-[8px] text-[18px]">Add Bio</p>
                </div>
                <div>
                  <textarea
                    onChange={(e) => setBio(e.target.value)}
                    className="border border-[#E1E1E1] p-[10px] w-full rounded-[8px] focus:outline-none"
                    placeholder="Introduce yourself to web3..."
                    name=""
                    id=""
                    cols="10"
                    rows="4"
                    value={bio}
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div>
            {updateProfileState?.loading ? (
              <div className=" flex justify-end">
                <button
                  disabled={updateProfileState?.loading}
                  type="submit"
                  className="w-[135px] h-[48px] bg-[#1022DC] text-white rounded-[12px] mt-[30px] flex items-center justify-center text-[16px]"
                >
                  <div role="status " className="flex items-center">
                    <svg
                      className="inline mr-2 w-[20px] h-[20px] text-gray-200 animate-spin dark:text-gray-600 fill-gray-600 dark:fill-gray-300"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill"
                      />
                    </svg>
                  </div>
                  Saving
                </button>
              </div>
            ) : (
              <div className="button_hover flex justify-end">
                <button
                  disabled={updateProfileState?.loading}
                  type="submit"
                  className="w-[135px] h-[48px] bg-blue text-white rounded-[12px] mt-[30px] flex items-center justify-center text-[16px]"
                >
                  {buttonText}
                </button>
              </div>
            )}
          </div>
        </form>
      </div>
    </>
  );
}
